import React from 'react';
function FormItemMessage(_a) {
    var message = _a.message;
    return React.createElement("div", { className: "elmo-formitem__control__help" }, message);
}
export default FormItemMessage;
